"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @preferred
 */
var service_1 = require("../service");
var Cultures;
(function (Cultures) {
    function getApplicationCultures() {
        var service = new service_1.EVAService("ListApplicationCultures");
        return new Promise(function (resolve, reject) {
            // Perform the call and capture the resulting promise
            //
            service.call().then(function (serviceResult) {
                var cultures = serviceResult.response.Result;
                resolve(cultures);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    }
    Cultures.getApplicationCultures = getApplicationCultures;
})(Cultures = exports.Cultures || (exports.Cultures = {}));
